import { css } from 'styled-components';

export const boxShadow = css`
  box-shadow: 0px 0px 80px rgba(0, 0, 0, 0.07), 0px 0px 33.4221px rgba(0, 0, 0, 0.0503198), 0px 0px 17.869px rgba(0, 0, 0, 0.0417275),
    0px 0px 10.0172px rgba(0, 0, 0, 0.035), 0px 0px 2.21381px rgba(0, 0, 0, 0.0196802);
`;
